/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandAzure = createReactComponent("brand-azure", "IconBrandAzure", [
  ["path", { d: "M6 7.5l-4 9.5h4l6 -15z", key: "svg-0" }],
  ["path", { d: "M22 20l-7 -15l-3 7l4 5l-8 3z", key: "svg-1" }]
]);

export { IconBrandAzure as default };
//# sourceMappingURL=IconBrandAzure.js.map
